import React from 'react';
import PropTypes from 'prop-types';
import Row from './Row';
import { QUESTION_MATRIX_OPEN_ENDED_CONSTANT_SUM_TYPES } from '../constants';

function getInfoMessage({ getText, total = 0 }) {
  const text = getText('warnings.matrixConstantSumOpenEndedNote').replace(
    'XXXX',
    `<span class="font-bold">${total}</span>`,
  );
  // eslint-disable-next-line react/no-danger
  return <span dangerouslySetInnerHTML={{ __html: text }}></span>;
}

export default function OpenEndedConstantSum({
  rows,
  openEndedStyle,
  openEndedInputSize,
  openEndedSignPlacement,
  openEndedSign,
  openEndedConstantSumType,
  min,
  max,
  decimals,
  total,
  getText,
}) {
  const lastIndex = rows.length - 1;
  const showInfoMessage =
    openEndedConstantSumType ===
    QUESTION_MATRIX_OPEN_ENDED_CONSTANT_SUM_TYPES.MUST_TOTAL;

  return (
    <div className="answers">
      {rows.map((row, index) => (
        <Row
          row={row}
          rowOrder={index}
          openEndedStyle={openEndedStyle}
          openEndedInputSize={openEndedInputSize}
          openEndedSignPlacement={openEndedSignPlacement}
          openEndedSign={openEndedSign}
          min={min}
          max={max}
          decimals={decimals}
          total={total}
          showDivider={lastIndex > index}
          getText={getText}
          openEndedConstantSumType={openEndedConstantSumType}
        />
      ))}
      {!showInfoMessage && (
        <div className="answer--matrix-open-ended-info-message-missing" />
      )}
      {showInfoMessage && (
        <p className="answer--matrix-open-ended-info-message">
          <span>
            {getInfoMessage({ getText, total })}{' '}
            {openEndedSign && (
              <span className="font-bold">{openEndedSign}</span>
            )}
          </span>
        </p>
      )}
    </div>
  );
}

OpenEndedConstantSum.propTypes = {
  rows: PropTypes.array,
  openEndedStyle: PropTypes.string,
  openEndedInputSize: PropTypes.string,
  openEndedSign: PropTypes.string,
  openEndedSignPlacement: PropTypes.string,
  openEndedConstantSumType: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  decimals: PropTypes.number,
  total: PropTypes.number,
  getText: PropTypes.func,
};
